import { Component, OnInit, Inject, DOCUMENT } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { Router } from '@angular/router';
import { Title, Meta } from '@angular/platform-browser';
import { UserData } from 'src/app/models';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    standalone: false
})
export class HeaderComponent implements OnInit {

  languages: any[];
  selectedLang: any;
  selectedId: number;
  defaultLang: string;

  constructor(
    public translate: TranslateService,
    @Inject(DOCUMENT) private document: Document,
    private router: Router,
    private titleService: Title,
    private metaService: Meta,
    private userData: UserData,
  ) {
    this.languages = [
      {
        id: 1,
        lang: 'ca',
        name: 'Català',
        /*
        lang: this.translate.instant('languages.ca.short'),
        name: this.translate.instant('languages.ca.name')
        */
      },
      {
        id: 2,
        lang: 'es',
        name: 'Español',
        /*
        lang: this.translate.instant('languages.es.short'),
        name: this.translate.instant('languages.es.name')
        */
      },
      {
        id: 3,
        lang: 'en',
        name: 'English',
        /*
        lang: this.translate.instant('languages.en.short'),
        name: this.translate.instant('languages.en.name')
        */
      }
    ];
    this.defaultLang = 'en';
  }

  public useLang(item: any): void {
    this.translate.setDefaultLang(item.lang);
    this.translate.use(item.lang);
    this.selectedLang = item;
    this.selectedId = item.id;
    this.document.documentElement.lang = this.selectedLang.lang;
    // this.titleService.setTitle(this.translate.instant('app.title'));
    this.setTitle();
    this.metaService.updateTag({ name: 'description', content: this.translate.instant('app.description') });
  }

  public isSelectedLang(item: any) {
    return this.selectedLang === item;
  }

  public getSelectedLang() {
    return this.selectedLang.lang;
  }

  public isIdentificationRoute() {
    if (this.router.url === '/identification'
        /* || this.router.url === '/' */) { return true; }
    else { return false; }
  }

  ngOnInit(): void {
    const configuredLanguange = this.userData.language;
    if (this.languages.find(l => l.lang === configuredLanguange)) {
      console.log('Used Browser languange: ' + configuredLanguange);
      this.translate.setDefaultLang(configuredLanguange);
      this.translate.use(configuredLanguange);
      this.selectedLang = this.languages.find(l => l.lang === configuredLanguange);
      this.selectedId = this.languages.find(l => l.lang === configuredLanguange).id;
    }
    else {
      console.log('Used Default languange: ' + this.defaultLang);
      this.translate.setDefaultLang(this.defaultLang);
      this.translate.use(this.defaultLang);
      this.selectedLang = this.languages.find(l => l.lang === this.defaultLang);
      this.selectedId = this.languages.find(l => l.lang === this.defaultLang).id;
    }
    this.document.documentElement.lang = this.selectedLang.lang;
    this.setTitle();
  }

  public setTitle() {
    this.translate.get('app.title').subscribe(name => {
      console.log('setTitle: ' + name);
      this.titleService.setTitle(name);
    });
  }

}
